module.exports = __webpack_public_path__ + "img/Bluparadise_Valencia_Nuria_Daviu_WEB-001.9018aaa8.jpg";